import { getBearerAuthHeaders } from "@/lib/authSession";
import { fetchWithAuthRetry } from "@/lib/authedRequest";
import { readStoredPresenceStatus } from "@/lib/agentPresenceStorage";
import { humanAgentInboxUrl, inboxWorkspaceHeaders, isHumanAgentInboxLive } from "@/lib/inboxLiveConfig";

/**
 * @param {"available" | "away"} status
 * @param {{ workspaceId?: string | null }} [opts]
 */
export async function postAgentPresence(status, { workspaceId } = {}) {
  if (!isHumanAgentInboxLive()) {
    return { is_online: status === "available", status: status === "available" ? "online" : "offline" };
  }
  const buildRequest = () =>
    fetch(humanAgentInboxUrl("/presence"), {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...getBearerAuthHeaders(),
        ...inboxWorkspaceHeaders(workspaceId),
      },
      body: JSON.stringify({ status }),
    });
  const res = await fetchWithAuthRetry(buildRequest);
  if (!res.ok) {
    const err = new Error(`presence_failed_${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

/**
 * @param {{ workspaceId?: string | null }} [opts]
 */
export async function postAgentPresenceHeartbeat({ workspaceId } = {}) {
  if (!isHumanAgentInboxLive()) return { is_online: false, status: "offline" };
  const buildHeartbeat = () =>
    fetch(humanAgentInboxUrl("/presence/heartbeat"), {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...getBearerAuthHeaders(),
        ...inboxWorkspaceHeaders(workspaceId),
      },
      body: "{}",
    });
  let res = await fetchWithAuthRetry(buildHeartbeat);
  // Older HA builds only expose POST /presence (no /presence/heartbeat sub-route).
  if (res.status === 404 || res.status === 405) {
    const status = readStoredPresenceStatus();
    res = await fetchWithAuthRetry(() =>
      fetch(humanAgentInboxUrl("/presence"), {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...getBearerAuthHeaders(),
          ...inboxWorkspaceHeaders(workspaceId),
        },
        body: JSON.stringify({ status }),
      }),
    );
  }
  if (!res.ok) {
    const err = new Error(`presence_heartbeat_failed_${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}
